<script setup lang="ts">
/**
 * Chiffres de l'association sous son nom (ex-carte « Impact ») — charte
 * « apple » (Karim 2026-10-18) : en grand, centrés. Seulement ceux que
 * l'association a choisi de montrer, et seulement s'il y a eu des dons.
 */
import { TITRE_SECTION_APPLE } from "~/utils/titresApple";

const props = defineProps<{
  totalCollecte: number;
  totalDonateurs: number;
  display?: { show_total_raised: boolean; show_total_donors: boolean } | null;
  formatAmount: (amount: number) => string;
}>();

const { t } = useI18n();

const chiffres = computed(() => {
  if (!(props.totalCollecte > 0)) return [];
  const c: { valeur: string; libelle: string }[] = [];
  if (props.display?.show_total_raised) c.push({ valeur: props.formatAmount(props.totalCollecte), libelle: t("association.infoColumn.collectesAuTotal") });
  if (props.display?.show_total_donors && props.totalDonateurs > 0) c.push({ valeur: String(props.totalDonateurs), libelle: t("association.infoColumn.donateurs") });
  return c;
});
</script>

<template>
  <dl v-if="chiffres.length" class="mt-12 flex flex-wrap justify-center gap-x-14 gap-y-6">
    <div v-for="c in chiffres" :key="c.libelle" class="text-center">
      <dt class="sr-only">{{ c.libelle }}</dt>
      <dd class="text-[34px] text-[#1d1d1f] sm:text-[44px]" :style="TITRE_SECTION_APPLE">{{ c.valeur }}</dd>
      <dd class="mt-1 text-[15px] font-medium text-[#6e6e73]" aria-hidden="true">{{ c.libelle }}</dd>
    </div>
  </dl>
</template>
